import { render, staticRenderFns } from "./PreguntaList.vue?vue&type=template&id=1b55ef19&scoped=true&"
import script from "./PreguntaList.vue?vue&type=script&lang=js&"
export * from "./PreguntaList.vue?vue&type=script&lang=js&"
import style0 from "./PreguntaList.vue?vue&type=style&index=0&id=1b55ef19&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b55ef19",
  null
  
)

export default component.exports